export default __webpack_public_path__ + "static/art-bird-25f36f8a6e822f2c14d3cbe85d573904.png";